import { useQuery } from '@tanstack/react-query';

import { MsbsApi } from 'api';
import { MSB_REGISTRATIONS_SEARCH_KEY } from 'hooks/keys';

export function useMsbRegistrationsSearch(dispensaryId: string, shouldNotifyOnChange = true) {
  const msbsApi = new MsbsApi();

  const { data: msbRegistrationSearchResults, isLoading: isLoadingMsbRegistrationSearchResults } = useQuery({
    enabled: !!dispensaryId.length,
    queryKey: [MSB_REGISTRATIONS_SEARCH_KEY, dispensaryId],
    queryFn: () => msbsApi.searchForRegistrations(dispensaryId),
    ...(!shouldNotifyOnChange && { notifyOnChangeProps: [] }),
    meta: {
      snackbarErrorMessage: 'There was an issue searching for registrations. Please contact support'
    }
  });

  return { msbRegistrationSearchResults, isLoadingMsbRegistrationSearchResults };
}
